/*
 * Copyright © 2015-2017 Serenova, LLC. All rights reserved.
 */

import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { createEpicMiddleware } from 'redux-observable';
import { isInIframe } from 'serenova-js-utils/browser';
import { rootEpic } from './epics';
import { fromJS } from 'immutable';
import reducer from './reducers';

const composeEnhancers = composeWithDevTools({
  name: window.location.hash === '#/supervisorToolbar' ? 'Cx Supervisor Toolbar' : 'Cx Configuration'
});

const saveStateToLocalStorage = (state) => {
  try {
    const localSerialisedState = JSON.stringify(state);
    localStorage.setItem("APPLICATION_STATE", localSerialisedState);
  } catch (e) {
    console.warn(e);
  }
}

const loadStateFromLocalStorage = ()  => {
  try {
    const localStoredState = localStorage.getItem("APPLICATION_STATE");
    return localStoredState !== null ? JSON.parse(localStoredState) : undefined;
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}
//persits the state on refresh and to access in other tab instances of browser...
const persistedState = isInIframe() ? fromJS(loadStateFromLocalStorage()) : undefined;
const store = createStore(reducer, persistedState, composeEnhancers(applyMiddleware(createEpicMiddleware(rootEpic))));
if (isInIframe()) {
  store.subscribe(() => saveStateToLocalStorage(store.getState().toJS()));
}

export default store; 